import React, { useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DialogContentText from "@mui/material/DialogContentText";
export default function MessageDialog({ show, message, dialogClose }) {
	const handleClose = useCallback(
		(event) => {
			dialogClose(false);
		},
		[dialogClose]
	);

	return (
		<Dialog
			open={show}
			onClose={handleClose}
			aria-labelledby="error-dialog-title"
			aria-describedby="error-dialog-description"
		>
			<DialogTitle id="error-dialog-title">Failed</DialogTitle>
			<DialogContent>
				<DialogContentText id="error-dialog-description">
					{message}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} autoFocus>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
}
